'use client';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';

import { SimilarRestaurant } from '@/lib/types/customer/restaurant/StoreProfile';

import SearchCard from '@/components/search/SearchCard';

type Props = {
  similarRestaurants: SimilarRestaurant[];
};
const SimilarRestaurantsCarousel = ({ similarRestaurants }: Props) => {
  return (
    <Swiper
      autoplay
      modules={[Pagination]}
      // centeredSlides={true}
      spaceBetween={2}
      slidesPerView={3}
      pagination={{
        clickable: true,
      }}
      id="fota-similar-restaurants-carousel"
      breakpoints={{
        280: {
          slidesPerView: 1,
        },
        660: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      }}
    >
      {similarRestaurants?.map((restaurant) => (
        <SwiperSlide key={restaurant?.id} className="px-3">
          <SearchCard restaurant={restaurant} />
        </SwiperSlide>
      ))}
      {/* {searchPickupData?.map((restaurant) => (
        <SwiperSlide key={restaurant?.id} className="px-3">
          <SearchCard
            cardType="pickup"
            {...restaurant}
            location={restaurant.location}
            key={restaurant?.id}
          />
        </SwiperSlide>
      ))} */}
    </Swiper>
  );
};

export default SimilarRestaurantsCarousel;
